import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Section from "../../components/Section";
import { useMutation, useQuery } from "@apollo/client";
import { ProfileContext } from "../../reducers/profile";
import {
  GET_FINALISTS_RATINGS,
  SET_FINISHED_FINALISTS_RESULTS,
  SET_JURIES_LOCKED,
  SET_FINALISTS_FINISHED,
} from "../../graphql_tags";

const FinishSection = styled(Section)`
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const FinishCard = styled.div`
  display: grid;
  grid-template-columns: auto 228px;

  div {
    padding: 17px 20px;

    :nth-child(2),
    :nth-child(3) {
      text-align: center;
    }
  }
`;

const FinishFinalist = styled(FinishCard)`
  height: 86px;
  cursor: pointer;

  :not(:first-child) {
    height: 107px;

    > :first-child {
      margin-right: 3px;
      border-top-left-radius: 10px;
    }

    > :last-child {
      margin-left: 3px;
      border-top-right-radius: 10px;
    }
  }

  :not(:last-child) {
    margin-bottom: 3px;

    > :first-child {
      border-bottom-left-radius: 10px;
    }

    > :last-child {
      border-bottom-right-radius: 10px;
    }
  }

  div {
    background-color: #ffffff;
    color: #000000;

    ${({ isTotal }) =>
      !isTotal &&
      `:nth-child(2) {
      color: #da5e50;
    }`};

    p {
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      margin: 0;
    }
  }
`;

const FinishHeader = styled(FinishCard)`
  div {
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;

    color: #777777;
  }
`;

const FinishFooter = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  align-items: center;

  button,
  p {
    font-weight: normal;
  }

  button {
    margin-left: 50px;
    min-width: 402px;
    height: 60px;

    font-size: 24px;

    color: #ffffff;

    background: ${({ isDisabled }) => (isDisabled ? "#777777" : "#339760")};
    cursor: ${({ isDisabled }) => isDisabled && "none"};
    border: none;
    box-sizing: border-box;
    border-radius: 10px;
  }

  p {
    font-size: ${({ isFinished }) => (isFinished ? "24" : "14")}px;
    line-height: 16px;

    color: #000000;
  }
`;

export default () => {
  const {
    state: { user_id, is_locked },
    dispatch,
  } = useContext(ProfileContext);
  const juries_id = user_id;
  const variables = { juries_id };

  const [scores, setScores] = useState([]);
  const [isLoaded, setLoaded] = useState(false);
  const [isDisabled, setDisabled] = useState(false);

  const [setFinishedFinalistsResults] = useMutation(
    SET_FINISHED_FINALISTS_RESULTS
  );
  const [setUserLocked] = useMutation(SET_JURIES_LOCKED);
  const [setFinalistsFinished] = useMutation(SET_FINALISTS_FINISHED);
  const getFinalistsRatings = useQuery(GET_FINALISTS_RATINGS, {
    variables: { juries_id },
  });

  const onCLickFinished = () => {
    setFinalistsFinished({ variables }).catch((error) => console.error(error));

    setUserLocked({
      variables: { id: user_id },
    }).catch((error) => console.error(error));

    setFinishedFinalistsResults().catch((error) => console.error(error));

    dispatch({
      type: "ME_RELOAD",
      payload: { is_locked: true },
    });
  };

  const handleFinalist = (inx) => {
    const selected = inx + 1;

    dispatch({
      type: "ME_RELOAD",
      payload: { selected },
    });
  };

  useEffect(() => {
    if (!getFinalistsRatings.loading) {
      const { finalists, ratings } = getFinalistsRatings.data;
      let _disabled = false;

      const results = finalists.map((obj1) => {
        for (let obj2 of ratings) {
          if (obj2.finalists_id === obj1.id) {
            obj1 = { ...obj1, ...obj2 };
          }
        }

        if (!_disabled) {
          if (!obj1.is_skipped && !obj1.total) {
            _disabled = true;
          }
        }

        return obj1;
      });

      setScores(results);
      setLoaded(true);
      setDisabled(_disabled);

      dispatch({ type: "ME_RELOAD", payload: { finalists: finalists.length } });
    }
  }, [getFinalistsRatings.loading]);

  return (
    <FinishSection>
      <FinishHeader>
        <div>Финалист</div>
        <div>Баллы</div>
      </FinishHeader>
      {isLoaded &&
        scores.map((finalist, index) => {
          return (
            <FinishFinalist
              key={finalist.id}
              isTotal={!!finalist.is_skipped || !!finalist.total}
              onClick={() => handleFinalist(index)}
            >
              <div>
                <p>{finalist.name}</p>
                <p>{finalist.library}</p>
              </div>
              <div>
                <p>
                  {!!finalist.is_skipped
                    ? "пропуск"
                    : finalist.total || "Пожалуйста, оцените конкурсанта"}
                </p>
              </div>
            </FinishFinalist>
          );
        })}
      <FinishFooter isFinished={is_locked} isDisabled={isDisabled}>
        <p>
          {is_locked
            ? "Данные направлены в Оргкомитет. Благодарим за работу в жюри конкурса!"
            : "Пожалуйста, проверьте баллы, которые вы поставили финалистам конкурса. До нажатия этой кнопки вы можете поменять баллы. Если вы нажмете кнопку «Отправить данные в Оргкомитет», поставленные вами баллы отправятся в обработку, изменить их будет нельзя."}
        </p>
        {!is_locked && (
          <button
            onClick={onCLickFinished}
            disabled={isDisabled ? "disabled" : null}
          >
            Отправить данные в Оркомитет
          </button>
        )}
      </FinishFooter>
    </FinishSection>
  );
};
